import logo from './logo.svg';
import './sassStyles/abstracts/_variables.scss';
import './App.scss';

import Navbar from './components/common/navbar/Navbar';

import Footer from './components/common/Footer/Footer';
import SectionCommety from './components/SectionCommety/SectionCommety';

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import PopUp, { PopUpContext } from './components/common/popUp/PopUp';
import Login from './components/forms/login/Login';
import SignUp from './components/forms/signup/signUp';
import ResetPassword from './components/forms/resetPassword/ResetPassword';
import ResetPasswordOTP from './components/forms/resetPassword/ResetPasswordOTP';
import NewPassword from './components/forms/resetPassword/NewPassword';
import Home from './components/pages/Home/Home';
import Blog from './components/blog/Blog';
import RadioButton from './components/common/button/RadioButton';
import Feedback from './components/feedback/Feedback';
import NotFound from './components/pages/NotFound/NotFound';
import MUN from './components/pages/MUN/MUN';
import BookingSummary from './components/pages/BookingSummary/BookingSummary';
import Recipt from './components/pages/Recipt/Recipt';
import BriefcasePage from './components/pages/BriefcasePage/BriefcasePage';
import BookingPage from './components/pages/BookingPage/BookingPage';

// import SectionBooking from './components/SectionBooking/SectionBooking';

// Recipt Page

// import SectionRecipt from './components/SectionRecipt/SectionRecipt';

// Booking Form page

// import BookingForm from './components/forms/BookingForm/BookingForm';

// import { Route } from 'react-router-dom';
// import { useContext, useEffect } from 'react';
// import PopUp, { PopUpContext } from './components/common/popUp/PopUp';
// import Login from './components/forms/login/Login';
// import SignUp from './components/forms/signup/signUp';
// import ResetPassword from './components/forms/resetPassword/ResetPassword';
// import ResetPasswordOTP from './components/forms/resetPassword/ResetPasswordOTP';
// import NewPassword from './components/forms/resetPassword/NewPassword';

// import Splide from '@splidejs/splide';
// import Navbar from './components/navbar/navbar';
// import Blog from './components/blog/Blog';
import AuthContext from './store/auth-context';

// new Splide( '.splide' ).mount();

function App() {
  const ctx = useContext(AuthContext);
  const popUp = useContext(PopUpContext);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!ctx.isLoggedIn) {
      popUp.showPopUp('small', <Login />, false);
    }
  }, []);

  useEffect(() => {
    if (ctx.isLoggedIn) {
      fetch('http://localhost:8080/auth/getUsername', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
        .then((res) => {
          if (res.status !== 200) {
            throw new Error('Failed to fetch username.');
          }
          return res.json();
        })
        .then((resData) => {
          // console.log('resData:', resData);
          setName(resData.name);
          setEmail(resData.email);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  // console.log(ctx.isLoggedIn);

  if (name && email !== null) {
    ctx.name = name;
    ctx.email = email;
  }

  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/MUN" component={MUN} />
          <Route exact path="/booking" component={BookingPage} />
          <Route exact path="/summary" component={BookingSummary} />
          <Route exact path="/recipt" component={Recipt} />
          <Route exact path="/briefcase" component={BriefcasePage} />
          <Route exact path="/blog" component={Blog} />
          <Route exact path="/feedback" component={Feedback} />
          <Route component={NotFound} />
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
